module.exports = __webpack_public_path__ + "img/man_3_2.616a36da.png";